export default {"src":"/_next/static/media/dark-purple-right.1116a41d.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};